import Stack from '@/design_system/Stack';
import { Workflow } from '@/models/workflow';

import { NewRequestInfoBanners } from './components/NewRequestInfoBanners';
import { RequestCustomFields } from './components/RequestCustomFields';
import { RequestDueAt } from './components/RequestDueAt';

export const GeneralSection = ({ workflow }: { workflow: Workflow }) => {
  return (
    <Stack gap="1rem">
      <NewRequestInfoBanners workflow={workflow} />
      <RequestDueAt workflow={workflow} />
      <RequestCustomFields workflow={workflow} />
    </Stack>
  );
};
